<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">Articles</h4>
        </div>
    </div>
</div>

@if(!fullyLoaded) {
    <div class="row justify-content-center">
      <div id="status">
          <div class="bouncing-loader">
              <div></div>
              <div></div>
              <div></div>
          </div>
      </div>
  </div>
}
@else {
<div class="card">
    <div class="card-body">
        <div class="table-responsive-sm">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table dt-responsive table-striped table-centered mb-0">
                <thead class="table-dark">
                    <tr>
                        <th>Name</th>
                        <th>Unit of measurement</th>
                        <th>Price</th>
                        <th>Status</th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-8 col-xs-8 mb-2 mt-2">
                <a routerLink="create" class="btn btn-secondary">Create new article</a>
            </div>
        </div>
    </div>
</div>
}